import React, { useEffect, useState } from "react";
import style from "../../style/DataListBody.module.scss";

import PenToSquareRegular from "../Icon/PenToSquareRegular";
import Patient_ReportReferral_XmarkRegular from "../Icon/Patient_ReportReferral_XmarkRegular";
import Patient_CheckReferral_XmarkRegular from "../Icon/Patient_CheckReferral_XmarkRegular";
import Patient_CheckReferral_CheckRegular from "../Icon/Patient_CheckReferral_CheckRegular";
import Patient_AmbulanceDeparture_CheckRegular from "../Icon/Patient_AmbulanceDeparture_CheckRegular";
import Patient_ArrivalLanseed_CheckRegular from "../Icon/Patient_ArrivalLanseed_CheckRegular";

import BellSlashRegular from "../Icon/BellSlashRegular";
import Case_AdmissionAssessment_CheckRegular from "../Icon/Case_AdmissionAssessment_CheckRegular";
import Case_IAAssessment_CheckRegular from "../Icon/Case_IAAssessment_CheckRegular";
import Case_AdmissionAssessment_XmarkRegular from "../Icon/Case_AdmissionAssessment_XmarkRegular";
import Case_IAAssessment_XmarkRegular from "../Icon/Case_IAAssessment_XmarkRegular";

import dayjs from "dayjs";

import RectangleListRegular from "../Icon/RectangleListRegular";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import HourglassHalfRegular from "../Icon/HourglassHalfRegular";

function DataListBody({ data }) {
  //console.log(data);
  const [selfIdentities, setSelfIdentities] = useState([]);
  const [otherIdentities, setOtherIdentities] = useState([]);
  //臨時帳號
  const [isTemp, setIsTemp] = useState(false);
  //console.log(selfIdentities);

  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
    setOtherIdentities(
      JSON.parse(localStorage.getItem("auth"))?.OtherIdentities
    );
    setIsTemp(JSON.parse(localStorage.getItem("auth"))?.IsTempAccount);
  }, []);

  return (
    <Table className={style.table}>
      <Thead>
        <Tr className={style.table_title}>
          <Th className={style.table_title_self}>收案編號</Th>
          <Th className={style.table_title_self}>轉出醫院</Th>
          <Th className={style.table_title_self}>建檔時間</Th>
          <Th className={style.table_title_self}>姓名/年齡/性別</Th>
          <Th className={style.table_title_self}>Onset &rarr; NIHSS</Th>
          <Th className={style.table_title_self}>病人動向</Th>
          <Th className={style.table_title_self}>收案狀態</Th>
          <Th className={style.table_title_self}>病歷編輯</Th>
          <Th className={style.table_title_self}>最新操作者</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data?.ListDatas?.map((v, i) => {
          return (
            <Tr key={i} className={style.table_body}>
              <Td className={style.table_body_self}>{v.CaseCode}</Td>
              <Td className={style.table_body_self}>{v.OriginalOrg}</Td>
              <Td className={style.table_body_self}>
                {dayjs(v.CreateDateTime).format("YYYY/MM/DD HH:mm")}
              </Td>
              <Td className={style.table_body_self}>
                <span style={{ paddingRight: "4px" }}>{v.Name}</span>
                {v.Age}
                {v.Sex === 1 ? "M" : ""}
                {v.Sex === 2 ? "F" : ""}
              </Td>
              <Td className={style.table_body_self}>
                {v.OnsetTime} &rarr; {v.Nihss}
              </Td>
              <Td className={style.table_body_self}>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      background: `${v.PatientStatus.HexColor}`,
                      borderRadius: "50%",
                      margin: "5px",
                    }}
                  ></span>
                  {v.PatientStatus.Name}
                  {otherIdentities && v.PatientStatus.Code === 1 ? (
                    <Patient_ReportReferral_XmarkRegular
                      rowId={v.RowId}
                      code={v.PatientStatus.Code}
                    />
                  ) : (
                    ""
                  )}
                  {otherIdentities && v.PatientStatus.Code === 2 ? (
                    <>
                      <Patient_CheckReferral_CheckRegular
                        rowId={v.RowId}
                        code={v.PatientStatus.Code}
                        time={dayjs(v.CreateDateTime).format(
                          "YYYY/MM/DD HH:mm"
                        )}
                        caseCode={v.CaseCode}
                        hospital={v.OriginalOrg}
                      />
                      <Patient_CheckReferral_XmarkRegular
                        rowId={v.RowId}
                        code={v.PatientStatus.Code}
                        time={dayjs(v.CreateDateTime).format(
                          "YYYY/MM/DD HH:mm"
                        )}
                        caseCode={v.CaseCode}
                        hospital={v.OriginalOrg}
                      />
                      <HourglassHalfRegular
                        rowId={v.RowId}
                        code={v.PatientStatus.Code}
                        time={dayjs(v.CreateDateTime).format(
                          "YYYY/MM/DD HH:mm"
                        )}
                        caseCode={v.CaseCode}
                        hospital={v.OriginalOrg}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  {otherIdentities && v.PatientStatus.Code === 3 ? (
                    <>
                      <Patient_AmbulanceDeparture_CheckRegular
                        rowId={v.RowId}
                        code={v.PatientStatus.Code}
                        time={dayjs(v.CreateDateTime).format(
                          "YYYY/MM/DD HH:mm"
                        )}
                        caseCode={v.CaseCode}
                        hospital={v.OriginalOrg}
                      />
                      <Patient_ReportReferral_XmarkRegular
                        rowId={v.RowId}
                        code={v.PatientStatus.Code}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  {(selfIdentities?.includes("neurology") ||
                    selfIdentities?.includes("er_nurse")) &&
                  v.PatientStatus.Code === 4 ? (
                    <>
                      <Patient_ArrivalLanseed_CheckRegular
                        rowId={v.RowId}
                        code={v.PatientStatus.Code}
                        caseCode={v.CaseCode}
                        hospital={v.OriginalOrg}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </p>
              </Td>
              <Td className={style.table_body_self}>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      background: `${v.CaseStatus.HexColor}`,
                      borderRadius: "50%",
                      margin: "5px",
                    }}
                  ></span>
                  {v.CaseStatus.Name}
                  {selfIdentities && v.CaseStatus.Code === 2 ? (
                    <BellSlashRegular
                      rowId={v.RowId}
                      code={v.CaseStatus.Code}
                    />
                  ) : (
                    ""
                  )}
                  {(selfIdentities?.includes("tbc_doctor") ||
                    selfIdentities?.includes("neurology")) &&
                  v.CaseStatus.Code === 4 ? (
                    <>
                      <Case_AdmissionAssessment_CheckRegular
                        rowId={v.RowId}
                        code={v.CaseStatus.Code}
                      />
                      <Case_AdmissionAssessment_XmarkRegular
                        rowId={v.RowId}
                        code={v.CaseStatus.Code}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  {(selfIdentities?.includes("tbc_doctor") ||
                    selfIdentities?.includes("neurology")) &&
                  v.CaseStatus.Code === 7 ? (
                    <>
                      <Case_IAAssessment_CheckRegular
                        rowId={v.RowId}
                        code={v.CaseStatus.Code}
                        caseCode={v.CaseCode}
                      />
                      <Case_IAAssessment_XmarkRegular
                        rowId={v.RowId}
                        code={v.CaseStatus.Code}
                        caseCode={v.CaseCode}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  {(selfIdentities?.includes("tbc_doctor") ||
                    selfIdentities?.includes("nurse")) &&
                  v.CaseStatus.Code === 8 ? (
                    <RectangleListRegular
                      rowId={v.RowId}
                      code={v.CaseStatus.Code}
                    />
                  ) : (
                    ""
                  )}
                </p>
              </Td>
              <Td className={style.table_body_self}>
                <PenToSquareRegular
                  navigatePath={`/ReferralEditData?rowId=${v.RowId}`}
                  // disabled={isTemp}
                />
              </Td>
              <Td className={style.table_body_self}>
                {v.UpdateUser + " "}
                {dayjs(v.UpdateDateTime).format("MM/DD HH:mm")}
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}

export default DataListBody;
